// extracted by mini-css-extract-plugin
export default {"titleCart":"MyCart_titleCart__Wal+d"};